import React from "react";
import { RiArrowRightSLine } from "react-icons/ri";

import { RegionalIcon, SuggestionItemWrapper } from "./styles";
import { SuggestionItemProps } from "./types";

/**
 * Componente SuggestionItem
 *
 * Exibe uma sugestão interativa, como um destino ou opção, com suporte a destaque opcional.
 *
 * @param {string} city - Nome da cidade associada à sugestão.
 * @param {string} code - Código associado à cidade (e.g., código IATA).
 * @param {boolean} [destak=false] - Define se o item deve ser destacado com ícone.
 * @param {() => void} [onClick] - Callback executado ao clicar no item.
 */
export const SuggestionItem: React.FC<SuggestionItemProps> = ({
  city,
  code,
  destak = false,
  onClick,
}) => (
  <SuggestionItemWrapper
    aria-label={`Select ${city} (${code})`}
    onClick={onClick}
    role="button"
  >
    {destak && (
      <RegionalIcon role="img">
        <RiArrowRightSLine />
      </RegionalIcon>
    )}
    {city} - ({code})
  </SuggestionItemWrapper>
);
